var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSideSearchIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4393 16.5607C15.0251 17.1464 15.9749 17.1464 16.5607 16.5607C17.1464 15.9749 17.1464 15.0251 16.5607 14.4393L14.4393 16.5607ZM10.4393 12.5607L14.4393 16.5607L16.5607 14.4393L12.5607 10.4393L10.4393 12.5607Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSideSearchIco);
export default __webpack_public_path__ + "static/media/profile_side_search_ico.f22e0a114f99ce4b5d3d5b6fd436cc9c.svg";
export { ForwardRef as ReactComponent };